import React__default from 'react';
import PropTypes from 'prop-types';
import { backgroundPresets } from '../../tools/constants.js';

var offsetSizes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
var propTypes = {
  /** Main lockup content (headlines, buttons, etc.) rendered inside the lockup wrapper */
  children: PropTypes.node.isRequired,
  /** Likely an unnecessary legacy alignment attribute for lockup content (anything but 'center' causes layout bugs) */
  align: PropTypes.oneOf(['center', 'left', 'right']),
  /** Background preset for the tout (image or color) */
  background: PropTypes.oneOf(backgroundPresets),
  /** Controls button group placement within the lockup */
  buttonPosition: PropTypes.oneOf(['bottom', 'default']),
  /** If true, applies inset styling to the lockup */
  isInset: PropTypes.bool,
  /** Width of the lockup content as a percentage of the tout */
  lockupWidth: PropTypes.oneOf(['30%', '40%', '50%', '60%', '70%']),
  /** Nudge the lockup by 1-15% from any side */
  offset: PropTypes.shape({
    bottom: PropTypes.oneOf(offsetSizes),
    left: PropTypes.oneOf(offsetSizes),
    right: PropTypes.oneOf(offsetSizes),
    top: PropTypes.oneOf(offsetSizes)
  }),
  /** Content for overlay spots in the four corners and middle left/right/center */
  positionedContent: PropTypes.shape({
    bottomCenter: PropTypes.node,
    bottomLeft: PropTypes.node,
    bottomRight: PropTypes.node,
    middleLeft: PropTypes.node,
    middleRight: PropTypes.node,
    topCenter: PropTypes.node,
    topLeft: PropTypes.node,
    topRight: PropTypes.node
  }),
  /** Visual theme for color contrast */
  theme: PropTypes.oneOf(['default', 'inverse']),
  /** Optional video element to display as a background or alongside content */
  video: PropTypes.node,
  /** Horizontal flex alignment of the lockup */
  xFlex: PropTypes.oneOf(['center', 'left', 'right']),
  /** Vertical flex alignment of the lockup */
  yFlex: PropTypes.oneOf(['bottom', 'middle', 'top'])
};
function Tout(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? undefined : _ref$background,
    _ref$buttonPosition = _ref.buttonPosition,
    buttonPosition = _ref$buttonPosition === void 0 ? 'default' : _ref$buttonPosition,
    children = _ref.children,
    _ref$isInset = _ref.isInset,
    isInset = _ref$isInset === void 0 ? false : _ref$isInset,
    _ref$lockupWidth = _ref.lockupWidth,
    lockupWidth = _ref$lockupWidth === void 0 ? '50%' : _ref$lockupWidth,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? {} : _ref$offset,
    _ref$positionedConten = _ref.positionedContent,
    positionedContent = _ref$positionedConten === void 0 ? {} : _ref$positionedConten,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'default' : _ref$theme,
    _ref$video = _ref.video,
    video = _ref$video === void 0 ? undefined : _ref$video,
    _ref$xFlex = _ref.xFlex,
    xFlex = _ref$xFlex === void 0 ? 'center' : _ref$xFlex,
    _ref$yFlex = _ref.yFlex,
    yFlex = _ref$yFlex === void 0 ? undefined : _ref$yFlex;
  var offsetBottom = offset.bottom,
    offsetLeft = offset.left,
    offsetRight = offset.right,
    offsetTop = offset.top;
  var bottomCenter = positionedContent.bottomCenter,
    bottomLeft = positionedContent.bottomLeft,
    bottomRight = positionedContent.bottomRight,
    middleLeft = positionedContent.middleLeft,
    middleRight = positionedContent.middleRight,
    topCenter = positionedContent.topCenter,
    topLeft = positionedContent.topLeft,
    topRight = positionedContent.topRight;
  var positionedContents = [{
    content: topLeft,
    verticalPosition: 'top',
    horizontalPosition: 'left'
  }, {
    content: topCenter,
    verticalPosition: 'top',
    horizontalPosition: 'center'
  }, {
    content: topRight,
    verticalPosition: 'top',
    horizontalPosition: 'right'
  }, {
    content: middleLeft,
    verticalPosition: 'middle',
    horizontalPosition: 'left'
  }, {
    content: middleRight,
    verticalPosition: 'middle',
    horizontalPosition: 'right'
  }, {
    content: bottomLeft,
    verticalPosition: 'bottom',
    horizontalPosition: 'left'
  }, {
    content: bottomCenter,
    verticalPosition: 'bottom',
    horizontalPosition: 'center'
  }, {
    content: bottomRight,
    verticalPosition: 'bottom',
    horizontalPosition: 'right'
  }].map(function (_ref2) {
    var content = _ref2.content,
      verticalPosition = _ref2.verticalPosition,
      horizontalPosition = _ref2.horizontalPosition;
    var testId = "".concat(verticalPosition, "-").concat(horizontalPosition);
    return content && /*#__PURE__*/React__default.createElement("div", {
      className: "tout-positional-content",
      "data-horizontal-position": horizontalPosition,
      "data-vertical-position": verticalPosition,
      "data-testid": testId,
      key: testId
    }, content);
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tout",
    "data-align": align,
    "data-background": background,
    "data-button-position": buttonPosition,
    "data-inset": isInset,
    "data-lockup-width": lockupWidth,
    "data-offset-bottom": offsetBottom,
    "data-offset-left": offsetLeft,
    "data-offset-right": offsetRight,
    "data-offset-top": offsetTop,
    "data-testid": "tout",
    "data-theme": theme,
    "data-x-flex": xFlex,
    "data-y-flex": yFlex
  }, positionedContents, video, /*#__PURE__*/React__default.createElement("div", {
    className: "lockup-wrapper"
  }, children));
}
Tout.propTypes = propTypes;

export { Tout as default };
//# sourceMappingURL=Tout.js.map
